import React from 'react';
import CenterListItem from "../../CenterListItem";
import {useTranslation} from "react-i18next";
import {formatDate} from "../../../utils/date.utils";
import {InfoCircleOutlined} from "@ant-design/icons";

interface ReportedHistoryProps {
    id: string
    imgProfileURL: string
    name: string
    date: string
    reportTopic: string
}

export const ReportedHistory: React.FunctionComponent<ReportedHistoryProps> = (props) => {
    const { t } = useTranslation();

    return (
        <CenterListItem
            avatarURL={props.imgProfileURL}
            title={props.name}
            description={formatDate(props.date)}
            avatarSize={48}
            tail={
                <div style={{ display: "flex", justifyItems: "center", justifyContent: "center", alignItems: "center"}}>
                    <InfoCircleOutlined /> <span style={{ marginLeft: "0.75rem"}}>{props.reportTopic}</span>
                </div>
            }
            itemStyle={{ border: 0}}
        />
    )
}